import React from "react";
import cmsUtils from "../../utils/cmsUtils";
import utils from "../../../utils";
import { SiteLink } from "../../../components";

export function BlogBanner(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};
  // Banner Image
  const heightSet = cmsUtils.payload(item, "HeightSet") || "standard";
  const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, "ImageUrl"));
  const linkUrl =
    cmsUtils.payload(item, "LinkUrl2") || cmsUtils.payload(item, "LinkUrl");
  const alignV = cmsUtils.payload(item, "VAlign") || "50%";
  const overlayOpacity = cmsUtils.payload(item, "OverlayOpacity") || "0";

  // Blog Properties
  const blogLocation = cmsUtils.payload(item, "BlogLocation") || "50%";
  const blogService = cmsUtils.payload(item, "BlogService") || "50%"; //scale
  const blogIndustry = cmsUtils.payload(item, "BlogIndustry") || "50%";
  const blogYear = cmsUtils.payload(item, "BlogYear") || "50%";

  const propertyPanel = (
    <div className='banner_properties_inner'>
      {blogIndustry && (
        <div className='blog_industry'>
          <img
            src='/assets/icons/blogicons/Blog-Icon-Industry.png'
            alt='blog industry'
          />
          {blogIndustry}
        </div>
      )}
      {blogYear && (
        <div className='blog_location'>
          <img
            src='/assets/icons/blogicons/Blog-Icon-Year.png'
            alt='blog year'
          />
          {blogYear}
        </div>
      )}
      {blogLocation && (
        <div className='blog_location'>
          <img
            src='/assets/icons/blogicons/Blog-Icon-Location.png'
            alt='blog location'
          />
          {blogLocation}
        </div>
      )}
      {blogService && (
        <div className='blog_service'>
          <img
            src='/assets/icons/blogicons/Blog-Icon-Size.png'
            alt='blog size'
          />
          {blogService}
        </div>
      )}
    </div>
  );

  // Caption
  const captionTitle = cmsUtils.payload(item, "CaptionTitle");
  const captionSubTitle = cmsUtils.payload(item, "CaptionSubTitle");
  const captionButton =
    cmsUtils.payload(item, "CaptionButton") &&
    cmsUtils.payload(item, "CaptionButton") !== ""
      ? cmsUtils.payload(item, "CaptionButton")
      : "READ MORE";

  const titlePanel = captionTitle ? (
    linkUrl ? (
      <div>
        <h1
          className='banner-item__title'
          dangerouslySetInnerHTML={{ __html: captionTitle }}
        ></h1>
        <div
          className='banner-item__subtitle'
          dangerouslySetInnerHTML={{ __html: captionSubTitle }}
        ></div>
        <SiteLink to={linkUrl} className='banner-item__link'>
          {" "}
          {captionButton}{" "}
        </SiteLink>
      </div>
    ) : (
      <>
        <h1
          className='banner-item__title'
          dangerouslySetInnerHTML={{ __html: captionTitle }}
        ></h1>
        <div
          className='banner-item__subtitle'
          dangerouslySetInnerHTML={{ __html: captionSubTitle }}
        ></div>
      </>
    )
  ) : null;

  const linkOverlay =
    linkUrl && !captionTitle ? (
      <SiteLink className='bannerItem__overlay' to={linkUrl}></SiteLink>
    ) : null;

  const cssClass = utils.classNames(
    "cms_item",
    "banner-item",
    `bannerWrapperSize--${heightSet}`,
    "blog-banner",
    "bannerSize",
    item.cssClass || item.anchorName || "",
    titlePanel && "bannerHasTitlePanel"
  );

  return (
    <div
      className={cssClass}
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
      id={item.anchorName}
      style={{
        backgroundImage: utils.css.bgUrlStyle(bgUrl),
        backgroundPositionY: alignV,
      }}
    >
      <div
        className='blue_overlay'
        style={{
          opacity: overlayOpacity,
        }}
      ></div>
      {titlePanel && (
        <div className='banner_item__text'>
          {titlePanel}
          <div className='banner_properties_panel'>{propertyPanel}</div>
        </div>
      )}
      {linkOverlay && linkOverlay}
    </div>
  );
}
